export default "__VITE_ASSET__092f46b8__"